export default __webpack_public_path__ + "static/media/bmjLogo.3408dba0.svg";